import {useMutation} from '@tanstack/react-query';
import axios from 'axios';
import * as Sentry from '@sentry/react';
import {useApiMutation} from '../../hooks/api/api';
import {UploadUrl} from '../../shared/api/definitions/import';

const useUploadFileMutation = () => {
  return useMutation<void, unknown, {url: string; file: File}>({
    mutationFn: ({url, file}) => {
      const contentSize = file.size;
      return axios.put(url, file, {
        headers: {
          'Content-Type': 'text/csv',
          'x-goog-content-length-range': `${contentSize},${contentSize}`,
        },
      });
    },
  });
};

export const useUploadFile = () => {
  const uploadFileMutation = useUploadFileMutation();
  const getSignedURLMutation = useApiMutation(UploadUrl);

  return useMutation<
    {
      cloudStorageBucket: string;
      cloudStorageFilePath: string;
      url: string;
    },
    unknown,
    {file: File}
  >({
    mutationFn: async ({file}) => {
      // Get a signed URL for the file upload
      const signedUrlResponse = await getSignedURLMutation.mutateAsync({
        contentSize: file.size,
      });

      // Upload the file to the signed URL (Cloud Storage)
      await uploadFileMutation.mutateAsync({
        url: signedUrlResponse.url,
        file,
      });

      // Return the signed URL response for further processing
      return signedUrlResponse;
    },
    onError: (error) => {
      Sentry.captureException(error);
    },
  });
};
